import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/services/api/apiRequest";
import type { MemberCard, OrganizationCard } from "../members.types";

/** The directory: active members *and* the organizations they steward, both
 * matched by one search term. keepPreviousData ports the source's
 * useStableQuery (no skeleton flicker while a search refetches). */
export function useDirectory(search: string) {
  return useQuery<{
    members: MemberCard[];
    organizations: OrganizationCard[];
    /** True when the viewer is a free member: no search, fewer fields. */
    preview: boolean;
    /** The directory's real size, which is not `members.length` when the
     * viewer is on the preview sample. */
    totals?: { members: number; organizations: number };
  }>({
    queryKey: ["afell", "directory", search],
    queryFn: () =>
      apiRequest(`/afell/directory/${search ? `?search=${encodeURIComponent(search)}` : ""}`),
    placeholderData: keepPreviousData,
  });
}

export default useDirectory;
